import { IconName } from "@nju/icons";
import { IBannerState } from "./types";

interface IStatusProps {
  iconName: IconName;
  title: string;
  text: string | React.ReactNode;
  isFoldable: boolean;
}

interface IGetChangeSimEsimBannerDataProps {
  bannerState: IBannerState;
}

export function getChangeSimEsimBannerData({
  bannerState,
}: IGetChangeSimEsimBannerDataProps): IStatusProps | undefined {
  if (bannerState === "completeReplacementQRCode") {
    return {
      title: "dokończ instalację karty",
      text: "Wygeneruj QR kod z kartą eSIM i zainstaluj ją na docelowym urządzeniu.",
      iconName: "sim-card",
      isFoldable: false,
    };
  }

  if (bannerState === "cardChangedInProgress") {
    return {
      title: "trwa wymiana karty",
      text: "Potrzebujemy jeszcze chwilę.",
      iconName: "sim-card",
      isFoldable: false,
    };
  }

  if (bannerState === "cardSimChangedCompleted") {
    return {
      title: "twoja karta została wymieniona",
      text: "Wyłącz i włącz telefon lub uruchom tryb samolotowy.",
      iconName: "sim-card",
      isFoldable: false,
    };
  }

  if (bannerState === "cardEsimChangedCompleted") {
    return {
      title: "twoja karta została wymieniona",
      text: "Wyłącz i włącz urządzenie, na którym zainstalowano eSIM lub uruchom tryb samolotowy.",
      iconName: "sim-card",
      isFoldable: false,
    };
  }

  if (bannerState === "completeReplacementAndActivatedCard") {
    return {
      title: "dokończ wymianę karty",
      text: "Jeśli masz już nową kartę SIM, dodaj ją i aktywuj. Po aktywacji stara karta przestanie działać.",
      iconName: "sim-card",
      isFoldable: true,
    };
  }

  if (bannerState === "deliveryInProgress") {
    return {
      title: "przesyłka w trakcie realizacji",
      text: "Twoja przesyłka z kartą SIM już wkrótce zostanie dostarczona.",
      iconName: "shopping-bag",
      isFoldable: true,
    };
  }

  if (bannerState === "orderPendingCancellation") {
    return {
      title: "zamówienie w trakcie anulowania",
      text: "Twoje zlecenie zostanie wkrótce anulowane.",
      iconName: "shopping-bag",
      isFoldable: false,
    };
  }

  return undefined;
}
